
import { span } from 'framer-motion/client'
import './emptyData.css'


export const EmptyDataComponent = ({ message, icon }) => {
    return (
        <div className='empty-component'>
            <span className="material-symbols-outlined search-off-style" aria-hidden="true" role="none">
                {icon ?

                    icon :
                    'search_off'

                }
            </span>
            {message ?
                <span className='ed-message text-center'>
                    {message}
                </span >
                :
                <span className='ed-message text-center'> No se encontraron registros</span>
             
            }

        </div>
    )
}
